import { createFileRoute } from '@tanstack/react-router'

import { useAuthStore } from '@/features/auth/store'
import { profileQueryOptions } from '@/features/profile/queries'
import { StoreProfilePage } from '@/features/store-profile/components/StoreProfilePage'

/** Store Settings › Profil Toko: one profile for the whole account (WEBLP-3241). */
export const Route = createFileRoute('/_authed/settings/store')({
  // The page renders its own retry state, so a failed preload must not throw.
  loader: ({ context }) => {
    const accountId = useAuthStore.getState().session?.user.id
    if (!accountId) return
    return context.queryClient
      .ensureQueryData(profileQueryOptions(accountId))
      .catch(() => undefined)
  },
  component: StoreProfilePage,
})
